import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
  LabelList,
} from 'recharts';

const AgeWeightBarChart = ({ data = [], label = 'Age Group', barColor = '#4F81BD' }) => {
  
  // const cleanedData = [
  //   { ageGroup: '0-30', totalWeight: 0 },
  //   { ageGroup: '30-60', totalWeight: 0 },
  //   { ageGroup: '60-90', totalWeight: 0 },
  //   { ageGroup: '90-180', totalWeight: 0 },
  //   { ageGroup: '180-365', totalWeight: 0 },
  //   { ageGroup: '365+', totalWeight: 0 }
  // ];

  const cleanedData = [
  { ageGroup: '0-30', totalWeight: 0 },
  { ageGroup: '30-60', totalWeight: 0 },
  { ageGroup: '60-90', totalWeight: 0 },
  { ageGroup: '3m–6m', totalWeight: 0 },    // 90–180 days
  { ageGroup: '6m–1y', totalWeight: 0 },    // 180–365 days
  { ageGroup: '1y+', totalWeight: 0 },      // 365+ days
]


  // Ensure data is an array
  if (!Array.isArray(data)) {
    console.error('Invalid data format, expected an array');
    return null;
  }

  // Process input data into age groups
  data.forEach((item, i) => {
    const weight = Number(item.totalWeight.toFixed(1));
    const age = Number(item.age);
 

    if (isNaN(weight) || isNaN(age)) {
      console.warn(`Invalid number at index ${i}:`, item);
      return;
    }

    if (age < 30) {
      cleanedData[0].totalWeight += weight;
    } else if (age < 60) {
      cleanedData[1].totalWeight += weight;
    } else if (age < 90) {
      cleanedData[2].totalWeight += weight;
    } else if (age < 180) {
      cleanedData[3].totalWeight += weight;
    }else if (age < 365) {
      cleanedData[4].totalWeight += weight;
    }
    else {
      console.log("w")
      cleanedData[5].totalWeight += weight; // 120+
    }
  });

  cleanedData.forEach(group => {
  group.totalWeight = Number(group.totalWeight.toFixed(1));
});


  return (
    <div className="w-full h-50">
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={cleanedData}
        margin={{ top: 20, right: 30, left: 20, bottom: 30 }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="ageGroup"
          label={{ value: label, position: 'insideBottom', offset: -10 }}
        />
        <YAxis
          label={{ value: 'Total Weight', angle: -90, position: 'insideLeft' }}
        />
        <Tooltip />
        <Bar dataKey="totalWeight" fill={barColor}>
          <LabelList dataKey="totalWeight" position="top" />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  </div>
  
  );
};

export default AgeWeightBarChart;
